import { fetchJson } from 'utils/fetch';

export const fetchRoles = () => fetchJson('/users/roles.json');



// WEBPACK FOOTER //
// ./src/modules/user/api/index.js